import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, Phone, Send } from "lucide-react";

const Reference = ({ r, op, n }) => <div className="rounded-lg border border-border p-3 space-y-2" data-testid="sim-more-reference">
  <p className="text-sm">Il tuo riferimento commerciale: <strong data-testid="sim-more-reference-name">{r.name}</strong></p>
  <div className="compact-actions"><div className="flex flex-wrap gap-2">
    {r.phone && <Button asChild size="sm" variant="outline" className="gap-1.5"><a href={`tel:${r.phone.replace(/\s/g, "")}`} data-testid="sim-more-call"><Phone className="w-4 h-4" />Chiama {r.phone}</a></Button>}
    {r.email && <Button asChild size="sm" variant="outline" className="gap-1.5"><a href={`mailto:${r.email}?subject=${encodeURIComponent(`Richiesta SIM ${op.name}`)}&body=${encodeURIComponent(`Ciao, mi servono ${n} SIM ${op.name}. Grazie!`)}`} data-testid="sim-more-email"><Mail className="w-4 h-4" />Scrivi</a></Button>}
  </div></div>
</div>;

export const SimMoreRequest = ({ qty, op, onClose }) => {
  const [ref, setRef] = useState(undefined);
  const [n, setN] = useState(qty || 10);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const open = qty !== null;
  useEffect(() => { if (open) { setN(qty || 10); setNote(""); } }, [open, qty]);
  useEffect(() => {
    if (!open || ref !== undefined) return;
    api.get("/me/upline").then((r) => { const c = r.data.contacts || []; setRef(c.find((x) => x.kind === "master") || c[0] || null); }).catch(() => setRef(null));
  }, [open, ref]);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sim-stock/request-more", { operator: op.key, quantity: Number(n), note });
      toast.success(`Richiesta inviata a ${data.reference}: ti ricontatta a breve`);
      onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Richiesta non inviata"); }
    finally { setBusy(false); }
  };
  return <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="sim-more-dialog">
      <DialogHeader>
        <DialogTitle>Richiedi più SIM {op.name}</DialogTitle>
        <DialogDescription>Questa quantità non si può ordinare da qui: chiedila al tuo riferimento commerciale.</DialogDescription>
      </DialogHeader>
      {ref && <Reference r={ref} op={op} n={n} />}
      {ref === null && <p className="text-sm text-muted-foreground" data-testid="sim-more-no-reference">La richiesta arriva al team Markoo Place, che ti ricontatta.</p>}
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="sim-more-qty">Quante SIM ti servono?</label>
        <Input id="sim-more-qty" type="number" min="1" value={n} onChange={(e) => setN(e.target.value)} data-testid="sim-more-qty" />
        <Textarea placeholder="Nota per il tuo riferimento (facoltativa)" maxLength={500} value={note} onChange={(e) => setNote(e.target.value)} data-testid="sim-more-note" />
      </div>
      <Button className="gap-2" disabled={busy || !(Number(n) >= 1)} onClick={send} data-testid="sim-more-send"><Send className="w-4 h-4" />{busy ? "Invio…" : "Invia richiesta"}</Button>
    </DialogContent>
  </Dialog>;
};
